import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DebugInfo = () => {
  const location = useLocation();
  const [debugEnabled, setDebugEnabled] = useState(false);
  const [info, setInfo] = useState({});

  useEffect(() => {
    // Enable debug mode by adding ?debug=true to URL
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.get('debug');
    const shouldShow = debugParam === 'true' || localStorage.getItem('debugMode') === 'true';
    
    setDebugEnabled(shouldShow);

    if (shouldShow) {
      setInfo({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        fullUrl: window.location.href,
        hostname: window.location.hostname,
        protocol: window.location.protocol,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        isReactRouter: true
      });
    }
  }, [location]);

  if (!debugEnabled) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      left: '10px',
      zIndex: 9999,
      background: 'rgba(0, 0, 0, 0.85)',
      color: '#0f0',
      padding: '15px',
      borderRadius: '5px',
      fontSize: '11px',
      fontFamily: 'monospace',
      maxWidth: '400px',
      maxHeight: '400px',
      overflow: 'auto',
      direction: 'ltr',
      textAlign: 'left'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px'
      }}>
        <strong style={{ color: '#0f0' }}>🔍 DEBUG MODE</strong>
        <button
          onClick={() => {
            localStorage.removeItem('debugMode');
            setDebugEnabled(false);
          }}
          style={{
            background: '#d32f2f',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '10px'
          }}
        >
          X
        </button>
      </div>
      
      <div style={{ marginBottom: '5px' }}>
        <strong>Path:</strong> {info.pathname}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Search:</strong> {info.search || '(none)'}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Hash:</strong> {info.hash || '(none)'}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Full URL:</strong> {info.fullUrl}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Hostname:</strong> {info.hostname}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Protocol:</strong> {info.protocol}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>React Router:</strong> {info.isReactRouter ? '✅ Active' : '❌ Not Active'}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Time:</strong> {new Date().toLocaleTimeString()}
      </div>
    </div>
  );
};

export default DebugInfo;
